<template>
  <div id="scheduleDetail_teamResult">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="
        !Object.keys(eventCompModeDatas).length ||
        eventCompModeDatas.data.length === 0
      "
    />
    <template v-else>
      <!-- 射箭 男子|女子 个人排名赛 特殊处理 -->
      <EVENTCOP_MODE_10
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_10' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_10>

      <!-- 雪车类的 双人综合成绩 特殊处理 -->
      <EVENTCOP_MODE_3
        v-if="
          localDataProp &&
          localDataProp.eventCompModeObj &&
          localDataProp.eventCompModeObj[tabTypeKey] === 'mode_3' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_3>

      <EVENTCOP_MODE_24
        v-else-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_24' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="tabTypeKey"
        :competitorType="localDataProp.competitorType"
        :isCombatFlag="localDataProp.isCombatFlag"
      ></EVENTCOP_MODE_24>

      <div
        class="note_box"
        v-show="
          eventCompModeDatas.annotation &&
          eventCompModeDatas.annotation.length > 0
        "
      >
        <span class="note_title" v-text="'注释'"></span>
        <span class="note_info">
          <span
            class="noteInfo_item"
            v-for="(item, index) in eventCompModeDatas.annotation"
            :key="index"
            v-text="`${item.name}：${item.explain}`"
          ></span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
// 适用： 其他 团队成绩（马术|射箭）
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import EVENTCOP_MODE_10 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_10.vue'
import EVENTCOP_MODE_24 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_24.vue'
import EVENTCOP_MODE_3 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_3.vue'

export default {
  name: 'scheduleDetail_teamResult',
  mixins: [cup_base_data_mixin],
  components: {
    NOT_DATA,
    EVENTCOP_MODE_24,
    EVENTCOP_MODE_10,
    EVENTCOP_MODE_3,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    scheduleDetailDatas: {
      type: Object,
      default: () => ({}),
    },
    localDataProp: {
      type: Object,
      default: () => ({
        datas: null, //初始化时为null, 一旦赋值过只能为正常数据||{}
        isHasData: true,
        eventCompMode: '', //mode_1
        type: '',
        competitorType: '',
        isCombatFlag: false, //对抗|非对抗
      }),
    },
  },
  watch: {
    localDataProp: {
      handler(newVal, oldVal) {
        console.debug('teamResult 1 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          if (
            this.result_team.sportsIds.includes(
              this.currSportsDetail.sportsId
            ) &&
            newVal.datas
          ) {
            let datas = newVal.datas[this.result_team.key]
            if (datas) {
              datas.annotation = datas.annotation ? datas.annotation : []
              this.eventCompModeDatas = JSON.parse(JSON.stringify(datas))
            } else {
              this.eventCompModeDatas = {}
            }
          } else {
            this.eventCompModeDatas = JSON.parse(
              JSON.stringify(newVal.datas ? newVal.datas : {})
            )
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      tabTypeKey: 'teamResult',
      eventCompModeDatas: null,
      result_team: {
        sportsIds: ['SBD', 'SKN', 'BOB', 'ARC', 'GAR'],
        key: 'result_team',
      },
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   // window.scrollTo(0, Math.floor(30.776 * this.vw2px))
    //   window.scrollTo(0, Math.floor((12.36+0.694) * this.vw2px))
    // })
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
#scheduleDetail_teamResult {
  padding-bottom: 2.083vw;
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
